var _rect, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 2,
    height: 14,
    fill: "#429E71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999996 16C0.999996 14.8954 1.89543 14 3 14L10 14L10 28C10 29.1046 9.10457 30 8 30L3 30C1.89543 30 0.999998 29.1046 0.999997 28L0.999996 16Z",
    fill: "#64AB88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0193C12.0001 13.9952 12.2041 11.958 14.4278 9.64C16.6631 7.30988 19.2647 4.69881 19.2647 4.69881C19.2647 4.69881 19.8235 1.78633 20.3824 1.20382C20.6759 0.89787 21.1852 0.987437 21.6026 1.14145C22.0623 1.31102 22.383 1.72716 22.5219 2.21434C22.6735 2.74617 22.8412 3.47837 22.8412 4.11647C22.8412 5.28152 22.2824 7.02911 22.2824 7.02911L20.6632 11.0004C20.5292 11.3293 20.7711 11.6892 21.1262 11.6892L28.5163 11.6892C29.1551 11.6892 29.7676 11.904 30.2193 12.2863C30.671 12.6687 30.8871 13.1873 30.8871 13.728C30.8871 14.2688 30.671 14.7873 30.2193 15.1697C29.7676 15.5521 29.1551 15.7669 28.5163 15.7669L28.7421 15.7669C29.3808 15.7669 29.9934 15.9817 30.4451 16.364C30.8967 16.7464 31 17.2749 31 17.8157C31 18.3564 30.8967 18.8651 30.4451 19.2474C29.9934 19.6298 29.3808 19.8446 28.7421 19.8446L28.0647 19.8446C28.7035 19.8446 29.3161 20.0594 29.7677 20.4417C30.2194 20.8241 30.4355 21.3427 30.4355 21.8834C30.4355 22.4242 30.2194 22.9428 29.7677 23.3251C29.3161 23.7075 28.7035 23.9223 28.0647 23.9223L27.2368 23.9223C27.8756 23.9223 28.4882 24.1371 28.9398 24.5195C29.3915 24.9018 29.5323 25.4204 29.5323 25.9611C29.5323 26.5019 29.3915 27.0205 28.9398 27.4028C28.4882 27.7852 27.8756 28 27.2368 28C27.2368 28 22.0803 28 20.4294 28C18.7785 28 12 28 12 28C12 28 12 15.891 12 14.0193Z",
    fill: "#64AB88"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 26.5,
    r: 1.5,
    fill: "#F6F4F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.7bed499a05f9be45aec5c3237cd405de.svg";
export { ForwardRef as ReactComponent };